module.exports = __webpack_public_path__ + "img/天津商业大学.a821c2f0.png";